import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const isFor = ['Mujeres que trabajan y necesitan resolver la cena en 15 minutos reales.', 'Dueñas de AirFryer que están cansadas de que la comida les salga seca.', 'Fanáticas de la milanesa y la papa frita que quieren comer más sano sin perder el sabor.', 'Madres que buscan que sus hijos coman casero sin ensuciar toda la cocina.'];
const isNotFor = ['Gente que tiene 3 horas por día para cocinar a fuego lento.', "Personas que buscan recetas de 'ultra-dieta' sin nada de sabor.", 'Chefs profesionales que no usan electrodomésticos modernos.'];
export function WhoIsFor() {
  return <section className="bg-charcoal py-24 px-6 md:px-12" data-id="element-130">
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-131">
        {/* Para vos si... */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-charcoal-light p-8 md:p-10 rounded-3xl border-t-4 border-green-500" data-id="element-132">
          <h3 className="font-serif text-2xl md:text-3xl font-bold text-cream mb-8" data-id="element-133">
            Para vos si...
          </h3>
          <ul className="space-y-6" data-id="element-134">
            {isFor.map((item, index) => <li key={index} className="flex items-start space-x-4" data-id="element-135">
                <Check className="text-green-500 w-6 h-6 flex-shrink-0 mt-1" data-id="element-136" />
                <span className="font-sans text-cream/80 leading-relaxed" data-id="element-137">
                  {item}
                </span>
              </li>)}
          </ul>
        </motion.div>

        {/* No es para vos si... */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-charcoal-light p-8 md:p-10 rounded-3xl border-t-4 border-red-500" data-id="element-138">
          <h3 className="font-serif text-2xl md:text-3xl font-bold text-cream mb-8" data-id="element-139">
            No es para vos si...
          </h3>
          <ul className="space-y-6" data-id="element-140">
            {isNotFor.map((item, index) => <li key={index} className="flex items-start space-x-4" data-id="element-141">
                <X className="text-red-500 w-6 h-6 flex-shrink-0 mt-1" data-id="element-142" />
                <span className="font-sans text-cream/80 leading-relaxed" data-id="element-143">
                  {item}
                </span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}